import { Component } from '@angular/core';
import { BreakpointState, Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  isHandset: Observable<BreakpointState> = this.breakpointObserver.observe([
    Breakpoints.Handset,
    Breakpoints.TabletPortrait,
    Breakpoints.TabletLandscape,
  ]);
  constructor(private breakpointObserver: BreakpointObserver) {}
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts